import { render, staticRenderFns } from "./videoslideshow.vue?vue&type=template&id=cb61c9ec&"
import script from "./videoslideshow.vue?vue&type=script&lang=js&"
export * from "./videoslideshow.vue?vue&type=script&lang=js&"
import style0 from "./videoslideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports